import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AbstractRestService } from '../../../../core/services/AbstractRestService';
import { ILibraryImageElement } from '../../interfaces';
import { tap } from 'rxjs/operators';
import { CreatorStateService } from '../app-services';

@Injectable({
  providedIn: 'root'
})
export class ImageElementsApiService extends AbstractRestService<unknown> {

  protected readonly basePath = '/auditoriums/image-elements';

  public getLibraryImageElements(): Observable<ILibraryImageElement[]> {
    return this.apiService.get(this.basePath).pipe(tap(els => CreatorStateService.libraryImageElements = els));
  }

  public addToLibrary(imageId: number): Observable<void> {
    return this.apiService.post(this.basePath, { imageId });
  }

  public removeFromLibrary(imageId: number): Observable<void> {
    return this.apiService.delete(`${this.basePath}/${imageId}`);
  }
}
